import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; 
import AssessmentForm from '../../components/AssessmentForm';

import CorporateHeader from "../../components/corporatedashboard/CorporateHeader";
import HealthWorkerDashboardSidebar from "../../components/global/HealthWorkerSidebar";

const AssessmentPage = () => {
  const [assessment, setAssessment] = useState(null);
  const [isOpen, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  // Get contractId from useParams
  const { id: contractId } = useParams();

  const handleSubmit = async (values) => {
    console.log('Submitting:', values);
   
  };

  return (
    <div className="flex justify-between bg-[#F9F9F9] font-Montserrat">
      <HealthWorkerDashboardSidebar isOpen={isOpen} setOpen={setOpen} />

      <div className="sm:w-screen space-x-2 lg:space-x-16 h-screen overflow-y-auto">
        <CorporateHeader isOpen={isOpen} setOpen={setOpen} />
        
        {/* Pass contractId to AssessmentForm */}
        <AssessmentForm 
          initialValues={assessment}
          onSubmit={handleSubmit}
          isUpdating={!!assessment}
          contractId={contractId} 
        />
      </div>
    </div>
  );
};

export default AssessmentPage;
